module.exports = __webpack_public_path__ + "static/media/time.56ecfaf2.svg";